import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class ProjectAPI {

  static ModelNo = 50;

  static list = (list, success, failure, logout) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    
    fetch(Config.app.link + 'api/project/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static count = (list, success, failure, logout) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const body = { filter: filter, page: page, perPage: perPage };
    
    fetch(Config.app.link + 'api/project/list/count', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static get = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/project/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static saveProject = (project, success, failure, logout) => {
    fetch(Config.app.link + 'api/project/add-edit', new Header('POST', project))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/project/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static massUpdate = (list, updates, success, failure, logout) => {
    const filter = list.filters;
    const body = { filter: filter, updates };
    
    fetch(Config.app.link + 'api/project/mass-update', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }
}

export default ProjectAPI;